import type {InventoryStem} from '@/domain/entities/InventoryStem';
import type {InventoryStemRepository} from '@/domain/interfaces/InventoryStemRepository';
import type {HttpClient} from '@/infrastructure/interfaces/HttpClient';
import type {InventoryStemDto} from './InventoryStemDto';
import {toDomain, toDto} from './InventoryStemMappers';

const PATH = 'inventory-stems/';

export class RestInventoryStemRepository implements InventoryStemRepository {
  constructor(private readonly httpClient: HttpClient) {}
  list = async (inventoryPlotUuid: string) => {
    const dtos = await this.httpClient.get<Array<InventoryStemDto>>(`${PATH}?inventoryPlotUuid=${inventoryPlotUuid}`);
    return dtos.map((dto) => toDomain(dto));
  };
  get = async (uuid: string) => {
    const dto = await this.httpClient.get<InventoryStemDto>(`${PATH}${uuid}`);
    return dto ? toDomain(dto) : undefined;
  };
  patch = async (domain: InventoryStem): Promise<InventoryStem> => {
    const dto = await this.httpClient.patch<InventoryStemDto, InventoryStemDto>(`${PATH}${domain.uuid}`, toDto(domain));
    return toDomain(dto);
  };

  delete = async (uuid: string) => {
    return this.httpClient.delete(`${PATH}${uuid}`);
  };
}
